import {Link} from 'react-router-dom';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import styled from '@emotion/styled';

export const TableLink = styled(Link)`
  display: inline-flex;
  margin: ${sizes.xSmall} 0;
  color: ${colors.primary1};
  text-decoration: none;
  cursor: pointer;
`;

export const ColoredTableLink = styled(TableLink)`
  color: ${colors.tertiary2};
`;
